export const COUNTRY_MOBILE_PREFIX = '+96';
export const passwordCriteria =
  "Password should have minimum length of 8, at least one uppercase character, at least one lowercase character, at least one number and at least one special character. Please note that '_' is not treated as special character";
export const localStorageActiveRoleKey = 'active-user-role';
